<div [ngClass]="{ 'flex flex-col h-full justify-between': !preview }">
  <app-header>
    <div primary-slot>
      <h3 class="font-medium text-xl text-grey-blue">
        {{ preview ? 'Upcoming Next Steps' : 'All Next Steps' }}
      </h3>
      <p class="text-xs text-grey-blue/80 mb-2">
        {{
          preview
            ? 'Stay on top of your workflow with your upcoming next steps. Can be assigned to customers or opportunities'
            : 'Review all your next steps in one place. Can be filtered by customer, opportunity, due date and more.'
        }}
      </p>
    </div>
    @if (preview && (paginationState$ | async)?.total_records > 5) {
      <button
        additional-slot
        id="view-all-button"
        class="btn-primary m-0 flex items-center justify-center w-min py-1"
        (click)="presentNextStepsModal()"
      >
        View All
      </button>
    }
    @if (!preview) {
      <button
        additional-slot
        id="close-modal-button"
        class="btn-primary m-0 flex items-center justify-center w-min p-1"
        (click)="closeModal()"
      >
        <ion-icon class="h-5 w-5" name="close-outline"></ion-icon>
      </button>
    }
  </app-header>
  @if ((loadingState$ | async) == 'loading') {
    <app-loader
      [loadingState]="'loading'"
      [helperText]="loadingText$ | async"
      [inline]="true"
      class="h-full w-full"
    ></app-loader>
  }
  @if (!preview && (loadingState$ | async) === 'loaded') {
    <div class="text-xs border-t border-grey-concrete">
      <app-advanced-search
        [searchOptionGroups]="searchOptionGroups"
        (filtersChange)="updateFilters($event)"
        [noResultsFound]="(nextSteps$ | async)?.length === 0 && (filters | keyvalue).length !== 0"
      ></app-advanced-search>
    </div>
  }
  <div [ngClass]="{ 'pb-6 flex flex-col h-full overflow-auto scroll-shadow': !preview }">
    @if ((loadingState$ | async) === 'loaded' && (paginationState$ | async)?.total_records === 0) {
      <div class="flex flex-col w-full items-center justify-center py-8 text-grey-blue/50">
        <ion-icon name="flag-outline" class="text-4xl mb-2"></ion-icon>
        @if (!filters || (filters | keyvalue).length === 0) {
          <p class="text-sm">No next steps recorded yet</p>
          <p class="text-xs">Log your first next step to help with workflow</p>
        }
      </div>
    }
    @if ((loadingState$ | async) === 'loaded' && (paginationState$ | async)?.total_records > 0) {
      <div class="w-full text-xs px-3">
        @for (nextStep of nextSteps$ | async; track nextStep.id) {
          <app-next-step-item
            data-cy="next-step-item"
            class="odd:bg-grey-light-concrete even:bg-white"
            [nextStep]="nextStep"
            [showLink]="true"
            [modalView]="!preview"
          ></app-next-step-item>
        }
      </div>
    }
  </div>
</div>
